import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { FacadeService } from '../services/facade.service';
import { LoginCode } from '../enum/login-code.enum';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(private facade: FacadeService, private router: Router) {}

  canActivateLogged() {
    return this.facade.guard.selectToken$.pipe(
      map((token) => {
        if (!token) {
          return this.router.createUrlTree(['/login']);
        }

        return !!token;
      })
    );
  }

  canActivateNotLogged() {
    return this.facade.guard.selectToken$.pipe(
      map((token) => {
        if (token) {
          return this.router.createUrlTree(['/']);
        }

        return !token;
      })
    );
  }

  canActivateMaintainance() {
    return this.facade.guard.selectIsMaintainance$.pipe(
      filter((isMaintainance) => isMaintainance !== undefined),
      map((isMaintainance) => {
        if (isMaintainance) {
          return this.router.createUrlTree(['/manutenzione']);
        }

        return !isMaintainance;
      })
    );
  }

  canActivateNotMaintainance() {
    return this.facade.guard.selectIsMaintainance$.pipe(
      filter((isMaintainance) => isMaintainance !== undefined),
      map((isMaintainance) => {
        if (!isMaintainance) {
          return this.router.createUrlTree(['/']);
        }

        return isMaintainance;
      })
    );
  }

  canActivateIsPasswordReset() {
    return this.facade.login.selectEsito$.pipe(
      filter((esito) => Boolean(esito)),
      map((esito) => {
        return esito !== LoginCode.CHANGE_PASSWORD;
      })
    );
  }
}
